<template>
    <div id="dashboard">
    <br>
        <v-container grid-list-md class="pa-2 container-width">
            <v-layout row wrap>
                <v-flex lg2 md4 sm12 xs12 id="select">
                  <v-select
                      :items="sortItems"
                      label="Sort By"
                      v-model="tableData.column"
                      single-line
                      item-text="name"
                      item-value="value"
                      dense
                      outline
                      @change="sortMethod()"
                      return-object
                  ></v-select>
                </v-flex>
                <v-flex lg1 md4 sm12 xs12 id="select">
                  <v-select
                      :items="statuses"
                      label="Select Status"
                      v-model="tableData.filter.syndication_status"
                      single-line
                      item-text="syndication_status"
                      item-value="syndication_status"
                      dense
                      outline
                      @change="sortMethod()"
                  ></v-select>
                </v-flex>
                 <v-flex lg1 md4 sm12 xs12 id="select">
                  <v-select
                      :items="agreement_dates"
                      label="Select Agreement Date"
                      v-model="tableData.filter.syndication_agreement_date"
                      single-line
                      item-text="syndication_agreement_date"
                      item-value="syndication_agreement_date"
                      dense
                      outline
                      @change="sortMethod()"
                  ></v-select>
                </v-flex>
                <v-flex lg1 md4 sm12 xs12 id="select">
                  <v-select
                      :items="lengths"
                      label="Select Agreement Date"
                      v-model="tableData.length"
                      single-line
                      dense
                      outline
                      @change="sortMethod()"
                  ></v-select>
                </v-flex>
                
                <v-flex lg2 md4 sm12 xs12 id="search">
                <v-text-field
                    solo
                    flat
                    label="Search"
                    v-model="tableData.search"
                    v-on:input="sortMethod()"
                    prepend-inner-icon="search"
                    outline
                ></v-text-field>
                </v-flex>
                
                <v-flex lg1 md3 sm12 xs12 id="search">
                  <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      full-width
                      max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="tableData.excel_origin_start_date"
                          label="Payout Start Date"
                          readonly
                          v-on="on"
                          hide-details
                        
                      ></v-text-field>
                    </template>
                      <v-date-picker 
                      @input="menu1 = false"
                      v-model="tableData.excel_origin_start_date"></v-date-picker>
                  </v-menu>
                </v-flex>
                
                <v-flex lg2 md3 sm12 xs12 id="search">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    full-width
                    max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="tableData.excel_origin_end_date"
                            label="Payout End Date"
                            readonly
                            v-on="on"
                            hide-details
                            
                        >
                         <template v-slot:append-outer>
                           <v-btn
                          class="ma-0"
                          flat
                          color="blue"
                          @click="reset">
                          Clear
                          <v-icon right>mdi-close-circle</v-icon>
                          </v-btn>
                          </template>  
                        </v-text-field>
                      </template>
                      <v-date-picker 
                      @input="menu2 = false"
                      v-model="tableData.excel_origin_end_date"></v-date-picker>
                      <!-- @change="getData()" -->

                    </v-menu>
                </v-flex>

                <v-flex lg1 md4 sm12 xs12>
                  <v-btn
                    small 
                    @click="exportSyndicatedDeals()"
                    color="primary"
                  >Export Report</v-btn>
                
                </v-flex>
              </v-layout>
            <v-progress-linear :indeterminate="processBar" height="3" class="my-0"></v-progress-linear>
            <v-data-table
                :headers="headers"
                :items="dealSyndication_payouts"
                item-key="id"
                :rows-per-page-items="[25, 50, {'text':'All','value':-1}]"
                :expand="expand"
                hide-actions
                disable-initial-sort
                :pagination.sync="pagination"
                @update:pagination="(e) =>onPagination(e)"
                >
                <template v-slot:items="props">
                    <tr @click="props.expanded = !props.expanded; openNotes(props.expanded); getPayouts(props.expanded, props.item)">
                    <td>{{props.item.syndication_agreement_date}}</td>
                    <td> {{props.item.syndication_status}}</td>
                    <td>{{ props.item.syndication_platform }}</td>
                    <td>{{ props.item.syndication_company_name }}</td>
                    <td>{{ props.item.contract_MID }}</td>
                    <td>{{ props.item.syndication_participation_percent }}%</td>
                    <td>{{ props.item.syndication_participation_amt | currency }}</td>
                    <td>{{ props.item.syndication_commission_amt | currency }}</td>
                    <td>{{ props.item.syndication_total_participation_amt | currency }}</td>
                    <td>{{ props.item.syndication_management_fee_percent }}% 
                      <span v-if="(props.item.syndication_management_fee_upfront == 1 || props.item.syndication_management_fee_upfront == 2)">Upfront</span>
                    </td>
                    <td>{{ props.item.syndication_part_rtr | currency }}</td>
                    <td>
                      <template v-if="props.item.syndication_status == 'Write-off' || props.item.syndication_status == 'Complete with discount'">
                        $0.00
                      </template>
                      <template v-else>
                        {{props.item.syndication_balance | currency}}
                      </template>
                      <!-- {{ props.item.syndication_balance | currency }} -->
                    </td>
                    <td>{{ getPercentage(props.item.paid_percentage) }}%</td>
                    <td>
                      {{ props.item.net_profit | currency }} ({{ getPercentagePaid((props.item.net_profit || 0), props.item.syndication_total_participation_amt) }}%)
                    </td>
                    <td>{{ props.item.performance ? props.item.performance : '' }}</td>
                    <td v-if="userpermission.syndawiz_fcs == 'On'">
                      <i
                        @click="redirectFcs(props.item.deal_unique_id)"
                        style="cursor: pointer; float:right; font-size:18px; color:grey;"
                        class="material-icons"
                      >input</i>
                    </td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                  <v-card flat style="background-color: #f1f2f5;">
                    <v-layout row wrap>
                      <v-flex lg6 md6 sm6 xs6>
                        <tr>
                            <th></th>
                            <th>Gross amount</th>
                            <th>Mgt Fee</th>
                            <th>Net Pay</th>
                            <th>Pay Date</th>
                            <th>No. Trans</th>
                        </tr>
                        <tr v-for="(o, index) in deal_payouts" :key="index" >
                            <td></td>
                            <td>{{ o.total_gross_amount | currency }}</td>
                            <td>{{ o.total_mgt_fee | currency }}</td>
                            <td>{{ o.total_net_pay | currency }}</td>
                            <td>{{ o.pay_date }}</td>
                            <td>{{ (o.numbers_of_transactions == null) ? 0 : o.numbers_of_transactions }}</td>
                        </tr>
                        <tr>
                            <td><strong>Total</strong></td>
                            <td><strong>{{ sumNetPay(deal_payouts, 'total_gross_amount') | currency }}</strong></td>
                            <td><strong>{{ sumNetPay(deal_payouts, 'total_mgt_fee') | currency }}</strong></td>
                            <td><strong>{{ sumNetPay(deal_payouts, 'total_net_pay') | currency }}</strong></td>
                            <td></td>
                            <td><strong>{{ sumNetPay(deal_payouts, 'numbers_of_transactions') }}</strong></td>
                        </tr>
                      </v-flex>
                      <v-flex lg6 md6 sm6 xs6>
                        <DealNotes :contract_MID="props.item.contract_MID" v-if="open_notes"/>
                      </v-flex>
                    </v-layout>
                  </v-card>

                </template>
            </v-data-table>
            <v-pagination
                v-model="tableData.page"
                :length="pages"
                :total-visible="7"
                @input="next"
            ></v-pagination>
        </v-container>
        <SelectRangeDatesSyndicated 
          :tableData="tableData" 
          v-if="dialog" 
          :dialog="dialog"
          @closeDialog="closeDialog"
        />
    </div>
</template>

<script>
import SelectRangeDatesSyndicated from './Dialogs/SelectRangeDatesSyndicated'
import axios from "axios";
import {URL, config} from '../../env'
import _ from "lodash";
import DealNotes from './Notes/DealNotes.vue'
import user_helper from '../helpers/user_helper'

export default {
  mixins: [user_helper],
  props: ['syndication_id'],
  components: {
    SelectRangeDatesSyndicated,
    DealNotes
  },
  data() {
    return {
      processBar: false,
      open_notes: false,
      menu1: false,
      menu2: false,
      dialog: false,
      expand: false,
      dealSyndication_payouts: [],
      tableData: {
        syndication_id: localStorage.getItem('syndication_id'),
        page: 1,
        length: 25,
        search: "",
        column:{name: 'Latest agreement date' , value: {column: 'deal_syndications.syndication_agreement_date', sortBy: 'DESC'}},
        filter:{
          syndication_status : 'All Status',
          syndication_agreement_date: 'All M/Y'
        },
        excel_origin_start_date: null,
        excel_origin_end_date: null,
      },
      pages: 0,
      pagination : {'sortBy': 'syndication_agreement_date', 'descending': true},
      sortItems: [
        {name: 'Latest agreement date' , value: {column: 'deal_syndications.syndication_agreement_date', sortBy: 'DESC'}}, 
        {name: 'Oldest agreement date' , value: {column: 'deal_syndications.syndication_agreement_date' , sortBy: 'ASC'}}, 
        {name: 'Highest net pay', value: {column: 'deal_payouts_tbl.total_net_pay', sortBy: 'DESC'}}, 
        {name: 'Lowest net pay', value: {column: 'deal_payouts_tbl.total_net_pay' , sortBy: 'ASC'}},
        {name: 'Highest Balance', value: {column: 'deal_syndications.syndication_balance', sortBy: 'DESC'}},
        {name: 'Lowest Balance', value: {column: 'deal_syndications.syndication_balance' , sortBy: 'ASC'}},
      ],
      deal_payouts: [],
      statuses: [],
      agreement_dates: [],
      lengths: [25,50,100]
    };
  },
  computed: {
    headers(){
      let headers = [
        {
          text: 'Agreement Date',
          align: 'left',
          sortable: true,
          value: 'syndication_agreement_date'
        },
        { text: 'Status', value: 'syndication_status' },
        { text: 'Platform', value: 'syndication_platform' },
        { text: 'Merchant', value: 'syndication_company_name' },
        { text: 'MID', value: 'contract_MID' },
        { text: '% syndicated', value: 'syndication_participation_percent' },
        { text: 'Syndication Amount', value: 'syndication_participation_amt' },
        { text: 'Commission Paid', value: 'syndication_commission_amt' },
        { text: 'Total Investment Cost', value: 'syndication_total_participation_amt' },
        { text: 'Mgt. Fees', value: 'syndication_management_fee_percent' },
        { text: 'Part RTR', value: 'syndication_part_rtr' },
        { text: 'Balance', value: 'syndication_balance' },
        { text: 'Paid in %', value: 'paid_percentage' },
        { text: 'Net profit', value: 'net_profit' },
        { text: 'Performance', value: 'performance' },
        // { text: 'Total Net Pay', value: 'netPay' }
      ]
      if(this.userpermission.syndawiz_fcs == 'On'){
        headers.push({ text: 'View FCS' })
        return headers
      }else{
        return headers
      }

    }
  },
  mounted(){
    this.getData()
    this.getStatuses()
  },

  methods:{
    onPagination(pagination){
      this.pagination = pagination;
      const sortColumnMap = {
        syndication_agreement_date: 'deal_syndications.syndication_agreement_date',
        syndication_status: 'deal_syndications.syndication_status',
        syndication_company_name: 'deal_syndications.syndication_company_name',
        contract_MID: 'deal_syndications.contract_MID',
        syndication_participation_percent: 'deal_syndications.syndication_participation_percent',
        syndication_total_participation_amt: 'deal_syndications.syndication_total_participation_amt',
        syndication_part_rtr: 'deal_syndications.syndication_part_rtr',
        anticipated_return_percent: 'anticipated_return_percent',
        syndication_balance: 'deal_syndications.syndication_balance',
        paid_percentage: 'paid_percentage',
        last_cleared_payment_date: 'deal_syndications.last_cleared_payment_date',
        collected_payment: 'balances_tbl.collected_payment',
        net_profit: 'net_profit',
      };
      this.tableData.column = {
        column: sortColumnMap[pagination.sortBy] || 'deal_syndications.syndication_agreement_date',
        sortBy: pagination.descending ? 'DESC' : 'ASC',
        name: pagination.sortBy || 'Lowest net pay',
        value: {
          column: sortColumnMap[pagination.sortBy] || 'deal_payouts_tbl.total_net_pay',
          sortBy: pagination.descending ? 'DESC' : 'ASC'
        }
      };

      if(pagination.sortBy == 'net_profit'){
        let sort = pagination.descending ? 'DESC' : 'ASC';
        let colName = 'net_profit';
       
        this.tableData.column = {
          column: 'net_profit',
          sortBy: sort,
          name: colName,
          value: {
            column: 'net_profit',
            sortBy: sort
          }
        }
      }
      this.tableData.page = pagination.page;
      this.tableData.length = pagination.rowsPerPage;
      this.getData();
    },
    netProfit(totalPayouts, totalInvestmentCost){
      let totalNetPayout = totalPayouts ? parseFloat(totalPayouts) : 0
      let totalInvestment = totalInvestmentCost ? parseFloat(totalInvestmentCost) : 0
      const profit =  totalNetPayout - totalInvestment

      if(profit < 0) return 0
      else return profit
    },
    getPercentagePaid(netProfit, participationAmt){
      let net_profit = netProfit ? parseFloat(netProfit) : 0;

      if(net_profit<0) return 0

      let participation_amt = participationAmt ? parseFloat(participationAmt) : 0;
      let val =  participation_amt == 0 ? 0 : ((net_profit / participation_amt) * 100).toFixed(2)
      return val
    },  
    getPercentage(val){
      if(val)
        return (val * 100).toFixed(2)
      else
        return 0
    },
    openNotes(status){
      this.open_notes = status
      
    },
    getPayouts(status, item){
      if(status){
        axios.post(`${URL}/api/payouts/deal_payouts`, {
          syndication_id: item.syndication_id,
          contract_MID: item.contract_MID,
        }).then(res=>{
          this.deal_payouts = res.data
        })
      }else{
        this.deal_payouts = []
      }
    },
    redirectFcs(deal_unique_id){
      let route = this.$router.resolve({
        path: `fcs/${deal_unique_id}`
      });
      window.open(route.href, "_blank");
    },
    reset(){
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null
      this.getData()
    },
    closeDialog(){
      this.dialog = false
    },
    exportSyndicatedDeals(){
      // this.dialog = true
      let start = this.tableData.excel_origin_start_date
      let end = this.tableData.excel_origin_end_date
      let file ="syndicated_deals("+start + ' - ' + end +").xlsx"
      axios({
        url: `${URL}/api/payouts/export_syndicated_deals`,
        method: "POST",
        responseType: "blob", // important
        data: this.tableData
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file);
        document.body.appendChild(link);
        link.click();
      }).catch(err=>{
      })
    },
    getStatuses(){
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null
      axios.get(`${URL}/api/payouts/get_dealsyndication_aggrementDate_statuses/` + this.tableData.syndication_id).then(res=>{
        this.statuses = res.data.statuses
        this.statuses.unshift({syndication_status: 'All Status'})
        
        this.agreement_dates = res.data.agreement_dates
        this.agreement_dates.unshift({syndication_agreement_date: 'All M/Y'})
      })
    },
    sumNetPay(data, key){
      return _.sumBy(data, function (res) {
        if(res[key]) return parseFloat(res[key]);
        else return 0;
      });
    },
    sortMethod(){
      this.getData()
    },
    async getData(){
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null

      this.processBar = true
      await axios.post(`${URL}/api/payouts/get_dealsyndication_payouts`,this.tableData).then(res=>{
        this.processBar = false
        this.dealSyndication_payouts = res.data.deal_syndication_data.data
        this.paginationMeth(res.data.deal_syndication_data);
      }).catch(err=>{
        this.processBar = false
      })
    },
    paginationMeth(res) {
      this.tableData.page = Math.ceil(res.to / this.tableData.length);
      this.pages = Math.ceil(res.total / this.tableData.length);
    },
    next(e) {
      this.tableData.page = e;
      this.getData();
    }
  }
};
</script>

<style scoped>
/* table.v-table tbody td, table.v-table tbody th {
    height: 30px!important;
} */

.container-width {
  max-width: 100% !important;
}

.custom-width {
    width: 20% !important;
  }

@media screen and (max-width: 750px) {
  .custom-width {
    width: 30% !important;
  }
}

.nav-item {
  text-align: center;
}
.nav-item button {
  padding: 5px;
  text-align: left;
  font-size: 11px;
  line-height: 1.5;
  font-weight: 400;
  width: 100%;
  margin: 0;
  margin-bottom: 7px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.overflow-section::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
.overflow-section {
  -ms-overflow-style: none;
}

.overflow-section {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 540px;
  max-height: 540px;
}

.side-list {
  font-size: 13px !important;
  height: 100%;
  font-weight: bold !important;
}

.th-style {
  height: 25px !important; 
  text-align: left; 
  color: #000;
}
</style>
